// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeatureEntities_feature-entities__BhNzH {
  display: flex;
  padding: 32px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_title__lmDBJ {
  color: var(--grey-text);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_institution-item__2Cxlp .FeatureEntities_institution-item--brief__cStIJ {
  display: flex;
  padding-right: 8px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_institution-item__2Cxlp .FeatureEntities_institution-item--rank__T225J {
  color: var(--grey-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 18px */
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--title__R\\+Ojx {
  display: flex;
  padding-left: 20px;
  align-items: center;
  align-self: stretch;
  border-left: 4px solid var(--secondary-color);
  color: var(--text-1);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item__vfCnr {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background-color: var(--background-color-2);
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--cover__VjjZW {
  display: flex;
  height: 112px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--img__RroZo {
  height: 100%;
  width: 100%;
  object-fit: cover;
  background-color: var(--light-grey);
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item__content__2eZb2 {
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item__content__header__y1NKW {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item__content__body__PMfxw {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--avatar__x7twE {
  width: 75px;
  aspect-ratio: 1/1;
  border: 1px solid var(--light-grey);
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--name__g3Kk9 {
  text-transform: capitalize;
  color: var(--accent-color);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--statistics__fIkr\\+ {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--statistics--item__RbwBD {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-1);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--statistics__fIkr\\+ svg {
  width: 10px;
  height: 10px;
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--statistics__fIkr\\+ svg path {
  stroke: var(--accent-color);
}
.FeatureEntities_feature-entities__BhNzH .FeatureEntities_list__kn6IC .FeatureEntities_list--item--description__m8vau {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  align-self: stretch;
  overflow: hidden;
  color: var(--text-1);
  text-align: justify;
  text-overflow: ellipsis;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.46px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/FeatureEntities/FeatureEntities.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AA2BQ;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAzBV;AA4BQ;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AA1BV;AA+BM;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AA7BR;AAgCM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;AA9BR;AAgCQ;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA9BV;AAiCQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mCAAA;AA/BV;AAkCQ;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAhCV;AAkCU;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAhCZ;AAmCU;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAjCZ;AAqCQ;EACE,WAAA;EACA,iBAAA;EACA,mCAAA;AAnCV;AAsCQ;EACE,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AApCV;AAuCQ;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AArCV;AAuCU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AArCZ;AAwCU;EACE,WAAA;EACA,YAAA;AAtCZ;AAwCY;EACE,2BAAA;AAtCd;AA2CQ;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAzCV","sourcesContent":[".feature-entities {\n  display: flex;\n  padding: 32px 0px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  align-self: stretch;\n\n  .title {\n    color: var(--grey-text);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  .list {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    align-self: stretch;\n    // &:nth-child(even) {\n    //   .list--item {\n    //     &:nth-child(even) {\n    //       background-color: var(--background-color-1);\n    //     }\n\n    //     &:nth-child(odd) {\n    //       background-color: var(--background-color-2);\n    //     }\n    //   }\n    // }\n\n    // &:nth-child(odd) {\n    //   .list--item {\n    //     &:nth-child(even) {\n    //       background-color: var(--background-color-2);\n    //     }\n\n    //     &:nth-child(odd) {\n    //       background-color: var(--background-color-1);\n    //     }\n    //   }\n    // }\n\n    .institution-item {\n      .institution-item {\n        &--brief {\n          display: flex;\n          padding-right: 8px;\n          flex-direction: column;\n          align-items: flex-start;\n          flex: 1 0 0;\n        }\n\n        &--rank {\n          color: var(--grey-text);\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 150%; /* 18px */\n        }\n      }\n    }\n    .list {\n      &--title {\n        display: flex;\n        padding-left: 20px;\n        align-items: center;\n        align-self: stretch;\n        border-left: 4px solid var(--secondary-color);\n        color: var(--text-1);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        text-transform: uppercase;\n      }\n\n      &--item {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        align-self: stretch;\n        background-color: var(--background-color-2);\n\n        &--cover {\n          display: flex;\n          height: 112px;\n          flex-direction: column;\n          align-items: flex-start;\n          align-self: stretch;\n        }\n\n        &--img {\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n          background-color: var(--light-grey);\n        }\n\n        &__content {\n          display: flex;\n          padding: 12px;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 8px;\n          align-self: stretch;\n\n          &__header {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            align-self: stretch;\n          }\n\n          &__body {\n            align-self: stretch;\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 4px;\n          }\n        }\n\n        &--avatar {\n          width: 75px;\n          aspect-ratio: 1/1;\n          border: 1px solid var(--light-grey);\n        }\n\n        &--name {\n          text-transform: capitalize;\n          color: var(--accent-color);\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: normal;\n        }\n\n        &--statistics {\n          display: flex;\n          justify-content: space-between;\n          align-items: flex-start;\n          align-self: stretch;\n\n          &--item {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            color: var(--text-1);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n          }\n\n          svg {\n            width: 10px;\n            height: 10px;\n\n            path {\n              stroke: var(--accent-color);\n            }\n          }\n        }\n\n        &--description {\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: 3;\n          align-self: stretch;\n          overflow: hidden;\n          color: var(--text-1);\n          text-align: justify;\n          text-overflow: ellipsis;\n          font-size: 13px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: normal;\n          letter-spacing: 0.46px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feature-entities": `FeatureEntities_feature-entities__BhNzH`,
	"title": `FeatureEntities_title__lmDBJ`,
	"list": `FeatureEntities_list__kn6IC`,
	"institution-item": `FeatureEntities_institution-item__2Cxlp`,
	"institution-item--brief": `FeatureEntities_institution-item--brief__cStIJ`,
	"institution-item--rank": `FeatureEntities_institution-item--rank__T225J`,
	"list--title": `FeatureEntities_list--title__R+Ojx`,
	"list--item": `FeatureEntities_list--item__vfCnr`,
	"list--item--cover": `FeatureEntities_list--item--cover__VjjZW`,
	"list--item--img": `FeatureEntities_list--item--img__RroZo`,
	"list--item__content": `FeatureEntities_list--item__content__2eZb2`,
	"list--item__content__header": `FeatureEntities_list--item__content__header__y1NKW`,
	"list--item__content__body": `FeatureEntities_list--item__content__body__PMfxw`,
	"list--item--avatar": `FeatureEntities_list--item--avatar__x7twE`,
	"list--item--name": `FeatureEntities_list--item--name__g3Kk9`,
	"list--item--statistics": `FeatureEntities_list--item--statistics__fIkr+`,
	"list--item--statistics--item": `FeatureEntities_list--item--statistics--item__RbwBD`,
	"list--item--description": `FeatureEntities_list--item--description__m8vau`
};
export default ___CSS_LOADER_EXPORT___;
